import { render, staticRenderFns } from "./en-sentenceModfiyPage.vue?vue&type=template&id=3e25fef2&scoped=true&"
import script from "./en-sentenceModfiyPage.vue?vue&type=script&lang=js&"
export * from "./en-sentenceModfiyPage.vue?vue&type=script&lang=js&"
import style0 from "./en-sentenceModfiyPage.vue?vue&type=style&index=0&id=3e25fef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e25fef2",
  null
  
)

export default component.exports